import React from "react"
import Slider from "react-slick";
import { StaticQuery, graphql } from "gatsby"

const settings = {
  dots: true,
  arrows: true,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 760,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
};

const Testimonials = ({ locale }) => (

  <section className="about-testimonials">
    <div className="inner inner-about inner-about-testimonials">
      <hr style={{ marginTop: '-3rem', marginBottom: '2.5rem' }} />
      <h2 className="" style={{ marginBottom: '5rem', textAlign: 'center' }}>{locale === 'es-ES' ? "Testimonios" : "Testimonials"}</h2>
      <div className="component-card component-card-testimonials">
        <StaticQuery
          query={graphql`
              {
                allCosmicjsTestimonials {
                  edges {
                    node {
                      metadata {
                        testimonial_image {
                          imgix_url
                        }
                        testimonial_subtitle
                      }
                      title
                      content
                      locale
                    }
                  }
                }
              }
            `}
          render={data => (
            <Slider {...settings}>
              {data.allCosmicjsTestimonials.edges.filter((data) => data.node.locale === locale).map(({ node }, idx) => {
                return (
                  <div className="component-card component-card-testimonial" key={idx}>
                    <img src={`${node.metadata.testimonial_image?.imgix_url}?q=&w=196&h=196&fit=crop&crop=faces`} alt="" />
                    <div className="component-card-excerpt component-card-excerpt-testimonial" dangerouslySetInnerHTML={{ __html: node.content }} />
                    <div className="component-card-title-testimonial">{node.title}</div>
                    <div className="component-card-subtitle component-card-subtitle-testimonial">{node.metadata.testimonial_subtitle}</div>
                  </div>
                )
              })}
            </Slider>
          )}
        ></StaticQuery>
      </div>
    </div>
  </section>
)

export default Testimonials
